module.exports = __webpack_public_path__ + "static/media/AnswerLab.05dcfc91.png";